import { Box, Stack, Typography } from '@mui/material';

/**
 * Label / value row used inside `DetailSection`. Label sits on the left
 * with a fixed minWidth so the value columns line up vertically across
 * rows; on xs the label stacks above the value.
 *
 * When `children` is a primitive (string / number) the row renders it
 * with a default `'—'` fallback so empty values are visually
 * unambiguous. For richer content (chips, links, custom typography)
 * pass JSX and the row will render it verbatim.
 */
const DetailRow = ({ label, children, labelWidth = 180, py = 1.25 }) => {
  const isPrimitive = typeof children === 'string' || typeof children === 'number';
  const isEmptyPrimitive =
    isPrimitive && (children === '' || children === null || children === undefined);
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      spacing={{ xs: 0.5, sm: 2 }}
      sx={{ py }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ minWidth: labelWidth, flexShrink: 0 }}
      >
        {label}
      </Typography>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        {isPrimitive ? (
          <Typography
            variant="body2"
            color={isEmptyPrimitive ? 'text.disabled' : 'text.primary'}
            sx={{ wordBreak: 'break-word' }}
          >
            {isEmptyPrimitive ? '—' : children}
          </Typography>
        ) : (
          children ?? (
            <Typography variant="body2" color="text.disabled">
              —
            </Typography>
          )
        )}
      </Box>
    </Stack>
  );
};

export default DetailRow;
